<template>
	<svg
		:style="sizeStyle"
		:stroke-width="strokeWidth"
		class="app-icon"
		viewBox="0 0 24 24"
		aria-hidden="true"
		focusable="false"
	>
		<path
			v-for="(path, index) in paths"
			:key="index"
			:d="path"
		/>
	</svg>
</template>

<script setup>
import { computed } from 'vue'

defineOptions({ name: 'AppIcon' })

const ICON_PATHS = {
	download: ['M12 3v12', 'M12 15l-4.5-4.5', 'M12 15l4.5-4.5', 'M4 20h16'],
	globe: [
		'M12 2a10 10 0 100 20 10 10 0 000-20z',
		'M12 2c3 3 3 17 0 20',
		'M2 12h20',
		'M4 6.5h16',
		'M4 17.5h16'
	],
	call: [
		'M4.5 3.5h4l2 5-2.5 1.5a11 11 0 006 6L15.5 13.5l5 2v4a1.5 1.5 0 01-1.7 1.5A16.5 16.5 0 013 5.2 1.5 1.5 0 014.5 3.5z'
	],
	whatsapp: [
		'M12 3a9 9 0 00-7.7 13.6L3 21l4.5-1.2A9 9 0 1012 3z',
		'M8.5 8.6c.3-.7.6-.7 1-.7h.6c.2 0 .5 0 .7.6l.8 1.9c.1.3 0 .5-.2.7l-.5.5a7 7 0 003 3l.6-.6c.2-.2.4-.2.7-.1l1.9.8c.5.2.5.5.5.7v.6c0 .4 0 .7-.7 1a3 3 0 01-2.6.2 12 12 0 01-6.4-6.4 3 3 0 01.1-2.6z'
	],
	email: ['M3 6.5h18v11H3z', 'M3 7l9 6 9-6'],
	vcard: [
		'M4 5h16v14H4z',
		'M8.5 11.5a2 2 0 100-4 2 2 0 000 4z',
		'M5.5 17c.4-2 1.6-3 3-3s2.6 1 3 3',
		'M14 9.5h4',
		'M14 13h4'
	]
}

const props = defineProps({
	name: {
		type: String,
		required: true
	},
	size: {
		type: Number,
		default: 18
	},
	strokeWidth: {
		type: Number,
		default: 2
	}
})

const paths = computed(() => ICON_PATHS[props.name] || [])

// dimensions are dynamic, so they cannot live in the stylesheet
const sizeStyle = computed(() => ({
	width: `${props.size}px`,
	height: `${props.size}px`
}))
</script>

<style scoped lang="scss">
.app-icon {
	flex: none;
	fill: none;
	stroke: currentColor;
	stroke-linecap: round;
	stroke-linejoin: round;
}
</style>
